import { useRef, useState, useEffect } from 'react'
import { Link } from "react-router-dom";
import Slider from "react-slick";
import GetInTouch from "../GetInTouch/GetInTouch";
import sanityClient from '../../sanityClient';
import { Fancybox } from "@fancyapps/ui";
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { useParams } from 'react-router-dom';
import { PortableText } from '@portabletext/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from 'react-helmet';

var settings11 = {
  dots: false,
  arrows: false,
  infinite: true,
  speed: 1400,
  autoplaySpeed: 4000,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: false,
  pauseOnHover: false,
  cssEase: "ease",
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        autoplay: true,
      },
    },

    {
      breakpoint: 599,
      settings: {
        slidesToShow: 1,
        autoplay: true,
      },
    },
  ],
};

export default function ProjectDetail() {
  const { slug } = useParams(); // Assuming slug is passed in URL
  const [project, setProject] = useState(null);
  const [projects, setProjects] = useState([]);
  const [bannerData, setBannerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const sliderRef = useRef(null);

  const CustomArrows = () => (
    <div className="otherproj-arrows">
      <div className="default-arrowleft" onClick={() => sliderRef.current && sliderRef.current.slickPrev()}>
        <FontAwesomeIcon icon={faArrowLeft} />
      </div>
      <div className="default-arrowright" onClick={() => sliderRef.current && sliderRef.current.slickNext()}>
        <FontAwesomeIcon icon={faArrowRight} />
      </div>
    </div>
  );

  useEffect(() => {
    const fetchBannerData = async () => {
      try {
        const query = `*[_type == "bannerImageSection" && page == "projectDetail"][0]{
              "imageUrl": bannerImage.asset->url,
              altText,
              heading,
              
            }`;

        const data = await sanityClient.fetch(query);
        setBannerData(data);
        // console.log(data);
      } catch (error) {
        console.error('Error fetching banner data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBannerData();
  }, []);

  useEffect(() => {
    Fancybox.bind("[data-fancybox='gallery']", {
      // Any Fancybox custom options go here
      infinite: true,
      buttons: ["zoom", "close"],
      Thumbs: false,
    });

    return () => {
      Fancybox.destroy();
    };
  }, []);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "project" && slug.current == $slug ][0]{
              title,
              quote,
              description,
              projectYear,
              area,
              locality,
              city,
              state,
              category-> { title },
              subcategory-> { title },
              detailPageImage{asset->{url}},
              galleryImages[]{asset->{url}}
            }`, { slug }

      )
      .then((data) => {
        console.log("Projectdata", data);
        setProject(data)
      })
      .catch(console.error);
  }, [slug]);

  useEffect(() => {
    if (project?.category?.title) {
      sanityClient
        .fetch(
          `*[_type == "project" && category->title == $category && slug.current != $slug]{
              title,
              area,
              locality,
              city,
              slug,
              subcategory-> { title },
              smallListingPageImage{asset->{url}}
            }`,
          { category: project.category.title, slug }
        )
        .then((data) => {
          setProjects(data);
        })
        .catch(console.error);
    }
  }, [project, slug]);

  if (!project) return <div></div>;

  return (
    <>
      <Helmet>
        <link rel="preload" href="/assets/home/projectdetail-banner.webp" as="image" />
      </Helmet>

      <section className="sub-header project-sub">
        {bannerData ? (<img src={bannerData.imageUrl} className='img-responsive' alt="subhead"/>) : 
        (<img src="/assets/home/projectdetail-banner" className='img-responsive' alt="subhead"/>)}
        <div className="subheader-text">
          <h1 className="heading">{project.title}</h1>
        </div>
      </section>

      <section className="projectdetail-head">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6">
              <div className="prodetail-image">
                <img src="/assets/home/white-curve.svg" className='homebuild-shape' alt="shape" loading="lazy" />
                <img src="/assets/home/white-curve.svg" className='homebuild-shape-2' alt="shape" loading="lazy" />
                <img src={project.detailPageImage?.asset.url}
                  className='img-responsive' alt="About"/>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="prodetail-content">
                <span><img src="/assets/home/element.png" className='' alt="element"  loading="lazy" /></span>
                <h2 className="heading">{project.quote}</h2>
                <ul>
                  <li>{project.projectYear}</li>
                  <li>{project.area} sqft</li>
                  <li>{project.category?.title}</li>
                  <li>{project.locality}, {project.city}</li>
                </ul>
                <p className="wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                  <PortableText value={project.description} />
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className="prodetail-portfolio">
        <div className="container">

          <div className="row">
            {project.galleryImages?.map((image, index) => (
              image?.asset?.url ? ( // Check if image and image.asset.url exist
                <div key={index} className={index % 3 === 0 ? 'col-lg-12 col-md-12' : 'col-lg-6 col-md-6'}>
                  <a
                    data-fancybox="gallery"
                    className={index % 3 === 0 ? 'porfolio-view' : 'porfolio-view half-view'}
                    href={image.asset.url}
                  >
                    <img src={image.asset.url} className="img-responsive" alt="project" loading="lazy" />
                  </a>
                </div>
              ) : null // Render nothing if image or image.asset.url is null
            ))}


          </div>
        </div>
      </section>

      <section className="prodetail-other">
        <div className="container">
          <div className="row">

            <div className='col-lg-12'>
              <div className='vector-heading'>
                <img src="/assets/home/shape-vector.png" alt="vector"  loading="lazy" />
                <h4 className='heading'>other projects</h4>
              </div>
            </div>

            <div className='col-lg-12'>
              <Slider className='project-otherslider' ref={sliderRef} {...settings11}>
                {projects.map((project, index) => (
                  <div key={index} className='projectlist-box small-projectlist'>
                    <Link to={`/project/${project.slug.current}`}>
                      <img src={project.smallListingPageImage?.asset?.url || "./assets/home/project-list-small.webp"} className='img-responsive' alt="project" loading="lazy" />
                      <img src="/assets/home/white-curve.svg" className='projectlist-curve' alt="shape" loading="lazy" />
                      <div>
                        <h4>{project.title}</h4>
                        <span>{project.subcategory?.title}  • {project.area} sqft • {project.city}</span>
                      </div>
                    </Link>
                  </div>
                ))}
              </Slider>
              <CustomArrows />
            </div>

          </div>
        </div>
      </section>

      {project.category ? null : <GetInTouch />}
      
    </>
  )
}
